'use client'
import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { RiMapPinLine } from 'react-icons/ri'
import fallbackimage from 'public/images/fallback-image.png'
import CustomSwiper from '@/components/custom-swiper'
import { resolveImageUrl } from '@/utils/imageUtils'

const UNKNOWN_DESTINATION = 'Unknown Destination'

const StayExperienceSlider = ({ uniqueDestinations }) => {
  return (
    <div>
      <CustomSwiper
        slidesToShow={4}
        responsiveSlides={[
          { maxWidth: 400, slidesToShow: 1 },
          { maxWidth: 768, slidesToShow: 2 },
          { maxWidth: 1024, slidesToShow: 4 },
        ]}
        autoplay
        autoplaySpeed={3000}
        speed={500}
        showDots={false}
        showArrows={false}
        infinite
      >
        {uniqueDestinations.map((item) => (
          <div key={item.cityId} className='px-3'>
            <Link
              href={item.city ? `/property-listing?location=${encodeURIComponent(item.city)}` : '/property-listing'}
              className='block'
            >
              <div className='relative rounded-[20px] overflow-hidden shadow-md group h-[380px] cursor-pointer'>
                <Image
                  src={resolveImageUrl(item.imagePreview) || fallbackimage}
                  alt={item.city || UNKNOWN_DESTINATION}
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw"
                  className='object-cover'
                />
                <div className='absolute bottom-0 left-0 right-0 px-4 bg-gradient-to-t from-black/70 to-transparent'>
                  <div className='flex items-center text-white text-sm gap-2'>
                    <RiMapPinLine className='w-[18px] h-[18px]' />
                    <span className='font-medium text-[16px]'>
                      {item.city || UNKNOWN_DESTINATION}
                    </span>
                  </div>
                  <p className='text-[#FFFFFFCC] text-[12px] ml-[28px] pb-8'>
                    {item.property_count}{' '}
                    {item.property_count === 1 ? 'property' : 'properties'}
                  </p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </CustomSwiper>
    </div>
  )
}

export default StayExperienceSlider
